// @core/api/endpoints/analytics/create_saved_query.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateSavedQueryRequest,
  SavedQueryResponse,
} from '../../../types/analytics';

const BASE_PATH = '/analytics';

/**
 * Create saved query
 * Saves an analytics query configuration for reuse.
 */
export async function CreateSavedQuery(
  data: CreateSavedQueryRequest,
  options?: RequestOptions
): Promise<SavedQueryResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/analytics/saved-queries`;
  const requestOptions = options;
  return client.post<SavedQueryResponse>(requestPath, data, requestOptions);
}
